import { safeDayjs } from "@/helpers/dateHelper"
import { Dayjs } from "dayjs"
import { DirectDebitBankAccount as DirectDebitBankAccountRaw } from "@/api/backofficeRest/generated/model"
import {
  DirectDebitBankAccount,
  DirectDebitDefaultStatus,
  DirectDebitStatus,
  IDirectDebit,
} from "./directDebit.types"

export class DirectDebit implements IDirectDebit {
  id: number
  status: DirectDebitStatus
  paymentMethodType: string
  defaultStatus: DirectDebitDefaultStatus
  createdDttm: Dayjs
  fromDttm?: Dayjs
  toDttm?: Dayjs
  bankAccount?: DirectDebitBankAccount

  constructor(
    id: number,
    status: DirectDebitStatus,
    paymentMethodType: string,
    defaultStatus: DirectDebitDefaultStatus,
    createdDttm: Dayjs,
    fromDttm?: Dayjs,
    toDttm?: Dayjs,
    bankAccount?: DirectDebitBankAccountRaw,
  ) {
    this.id = id
    this.status = status
    this.paymentMethodType = paymentMethodType
    this.defaultStatus = defaultStatus
    this.createdDttm = createdDttm
    this.fromDttm = fromDttm
    this.toDttm = toDttm

    if (bankAccount) {
      this.bankAccount = {
        id: bankAccount.id,
        accountName: bankAccount.accountName,
        accountNumber: bankAccount.accountNumber,
        sortCode: bankAccount.sortCode,
        bankReference: bankAccount.bankReference,
        mandateReference: bankAccount.mandateReference,
        authRequestedDttm: safeDayjs(bankAccount.authRequestedDttm),
        authorisedDttm: safeDayjs(bankAccount.authorisedDttm),
      }
    }
  }

  get isActive(): boolean {
    return !this.isPending && this.status === "Active"
  }

  get isInactive(): boolean {
    return !this.isActive
  }

  get isPending(): boolean {
    return this.defaultStatus === "Pending"
  }
}
